import styled, { css } from 'styled-components'

export const Container = styled.footer`
  position: relative;
  background: #02e5ff;
  color: #000;
  z-index: 1;
  padding: 20px 20px 20px;
  @media (min-width: 768px) {
    padding: 40px 40px 20px;
  }
  border-top: ${props => props.$isHome ? 'none' : '1px solid #333'};
  ${props => !props.$isHome && css`
    margin-top: 9vh;
  `}
`

export const FooterWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin: 0px;
  width: 100%;
  flex-wrap: wrap;
  flex-direction: column;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`

export const Content = styled.div`
  width: 100%;
  margin-bottom: 0px;
  text-align: left;

  > h4 {
    font-weight: 700;
    font-size: 18px;
    margin: 0 0 20px 0;
    color: inherit;
    text-transform: uppercase;
    letter-spacing: 1px;
  }

  > div {
    margin: 12px 0;
    > a {
      display: inline-block;
      text-decoration: none;
      font-size: 15px;
      color: inherit;
      transition: all 0.2s ease-in-out;
      opacity: 0.8;

      &:hover {
        color: ${props => props.theme.colors.primary};
        padding-left: 5px;
        opacity: 1;
      }
    }
  }

  @media (min-width: 768px) {
    width: 45%;
  }

  @media (min-width: 992px) {
    width: 22%;
  }

  &.locations {
    @media (min-width: 992px) {
      width: 30%;
    }
  }
`

export const LocationContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const LocationRegion = styled.div`
  h5 {
    margin: 20px 0 10px 0;
    color: inherit;
    font-size: 16px;
    font-weight: 800;
  }

  .city-list {
    display: flex;
    flex-direction: column;
    gap: 8px;

    a {
      color: inherit;
      text-decoration: none;
      font-size: 14px;
      font-weight: 500;
      transition: all 0.2s;
      cursor: pointer;

      &:hover {
        color: ${props => props.theme.colors.primary};
        opacity: 0.7;
      }
    }
  }
`

export const FooterBottom = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  max-width: 1200px;
  margin: 30px auto 0 auto;
  width: 100%;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`

export const Description = styled.div`
  margin-top: 15px;
  font-size: 14px;
  line-height: 1.6;
  color: #888;
  max-width: 300px;
`

export const SocialGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;

  @media (min-width: 768px) {
    margin-bottom: 0;
  }

  a {
    color: #888;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #1a1a1a;
    transition: all 0.3s ease;

    > svg {
      font-size: 20px;
    }

    &:hover {
      background: ${props => props.theme.colors.primary};
      color: #fff;
      transform: translateY(-5px);
    }
  }
`

export const PoweredByOrdering = styled.p`
  text-align: center;
  margin: 0;
  display: flex;
  justify-content: center;
  font-size: 13px;
  color: #555;

  a {
    font-weight: 600;
    text-decoration: none;
    color: #888;
    margin-left: 5px;
    &:hover {
      color: ${props => props.theme.colors.primary};
    }
  }
`

export const LanguageWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  color: #888;

  svg {
    font-size: 20px;
  }
`
